import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/layout';

/**
 * NotFound page component
 * Displays a 404 error page with a link back to the homepage
 * 
 * @returns {JSX.Element} The rendered NotFound page
 */
const NotFound: React.FC = () => {
  return (
    <Layout>
      <div className="relative min-h-[calc(100vh-200px)] flex items-center justify-center px-6 py-12 lg:px-8">
        {/* Decorative elements matching Hero section */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none">
          <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-indigo-200 blur-3xl"></div>
          <div className="absolute top-1/3 -right-24 w-80 h-80 rounded-full bg-purple-200 blur-3xl"></div>
          <div className="absolute -bottom-24 left-1/4 w-72 h-72 rounded-full bg-pink-200 blur-3xl"></div>
        </div>
        
        {/* Subtle dot pattern overlay */}
        <div 
          className="absolute inset-0 opacity-10" 
          style={{
            backgroundImage: 'radial-gradient(#4f46e5 0.5px, transparent 0.5px)',
            backgroundSize: '12px 12px'
          }}
        ></div>
        
        <div className="relative z-10 text-center">
          <h1 className="text-9xl font-bold text-indigo-600">404</h1>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Page Not Found</h2>
          <p className="mt-6 text-lg leading-7 text-gray-600 max-w-md mx-auto">
            The page you're looking for doesn't exist or you don't have access to it.
          </p>
          <div className="mt-10">
            <Link
              to="/"
              className="rounded-md bg-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
